<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-width="104px"
    class="task_form"
  >
    <div class="row">
      <div class="col">
        <el-form-item label="合同名称:" prop="contractName">
          <el-input
            clearable
            v-model="form.contractName"
            size="mini"
            placeholder="请输入合同名称"
          ></el-input>
        </el-form-item>
      </div>
      <div class="col">
        <el-form-item label="合同编号:" prop="userBizNumber">
          <el-input
            clearable
            v-model="form.userBizNumber"
            size="mini"
            placeholder="请输入合同编号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="col">
        <el-form-item label="债务人姓名:" prop="debtorName">
          <el-input
            clearable
            v-model="form.debtorName"
            size="mini"
            placeholder="请输入债务人姓名"
          ></el-input>
        </el-form-item>
      </div>
      <div class="col">
        <el-form-item label="债务人手机号:" prop="debtorPhone">
          <el-input
            clearable
            v-model="form.debtorPhone"
            size="mini"
            placeholder="请输入债务人手机号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="button-box">
        <el-button
          class="reset-button"
          type="danger"
          size="mini"
          @click="onSearch"
          >查询</el-button
        >
        <el-button class="search-button" size="mini" @click="onReset"
          >重置</el-button
        >
      </div>
    </div>
    <div class="row">
      <div class="col">
        <el-form-item label="创建时间:" prop="signStartTimeArr">
          <el-date-picker
            type="daterange"
            start-placeholder="选择创建开始日期"
            end-placeholder="选择创建结束日期"
            value-format="yyyy-MM-dd"
            v-model="form.signStartTimeArr"
            style="width: 100%"
            size="mini"
            @change="signStartTimeChange"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div class="col">
        <el-form-item label="出证时间:" prop="certificateTimeArr">
          <el-date-picker
            type="daterange"
            start-placeholder="选择出证开始日期"
            end-placeholder="选择出证结束日期"
            value-format="yyyy-MM-dd"
            v-model="form.certificateTimeArr"
            style="width: 100%"
            size="mini"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div class="button-box"></div>
    </div>
    <div class="row">
      <div class="col">
        <el-form-item label="业务状态:">
          <div class="item-box">
            <div
              class="item"
              @click="onStatus()"
              :class="{ active: form.statusKey === '' }"
            >
              全部
            </div>
            <div
              v-for="(item, index) in statusOpitons"
              :key="item.key"
              class="item"
              @click="onStatus(item)"
              :class="{ active: form.statusKey === item.key }"
            >
              {{ item.name }}
            </div>
            <div class="status-item-line"></div>
            <div
              v-for="(item, index) in statusOpitons2"
              :key="item.key"
              class="item"
              @click="onStatus(item)"
              :class="{ active: form.statusKey === item.key }"
            >
              {{ item.name }}
            </div>
          </div>
        </el-form-item>
      </div>
      <div class="button-box">
        <!-- <el-button
          class="reset-button"
          type="danger"
          size="mini"
          style="width: 121px"
          @click="onExport"
          >导出</el-button
        > -->
      </div>
    </div>
  </el-form>
</template>
            
  <script>
import { timestampFormat } from "@lib/date.js";
export default {
  name: "search",
  props: {},

  components: {},

  data() {
    return {
      form: {
        contractName: "", // 合同名称
        userBizNumber: "", // 合同编号
        debtorName: "", // 债务人姓名
        debtorPhone: "", // 债务人手机号
        signStartTimeArr: [],
        certificateTimeArr: [],
        statusKey: "",
      },
      statusInfo: {},

      rules: {},
      //  办理中（status=10）、审核中（status=11）、已出证（status=12）、公证审核拒绝（status=14）到期未签署（15）
      // 【当天未完成】查询逻辑：  status=10&signStartTimeEnd=now()-1day
      // 【三天内未完成】查询逻辑：  status=10&signStartTimeEnd=now()-3day
      // 【七天内未完成】查询逻辑：  status=10&signStartTimeEnd=now()-7day
      // signStartTimeEnd的时间需要精确到秒，格式为："2023-11-12 12:12:30"
      statusOpitons: [
        {
          key: 10,
          status: 10,
          name: "办理中",
        },
        {
          key: 101,
          status: 10,
          signStartTimeEnd: timestampFormat(
            new Date().getTime() - 24 * 60 * 60 * 1000
          ),
          name: "当日未完成",
        },
        {
          key: 103,
          status: 10,
          signStartTimeEnd: timestampFormat(
            new Date().getTime() - 3 * 24 * 60 * 60 * 1000
          ),
          name: "拖延三天以上",
        },
        {
          key: 107,

          status: 10,
          signStartTimeEnd: timestampFormat(
            new Date().getTime() - 7 * 24 * 60 * 60 * 1000
          ),
          name: "拖延七天以上",
        },
        {
          key: 11,
          status: 11,
          name: "审核中",
        },
        {
          key: 12,
          status: 12,
          name: "已出证",
        },
      ],
      statusOpitons2: [
        {
          key: 14,
          status: 14,
          name: "审核拒绝",
        },
        {
          key: 15,
          status: 15,
          name: "未签署过期",
        },
      ],
    };
  },

  created() {},
  mounted() {},

  methods: {
    onReset() {
      this.form = {
        contractName: "", // 合同名称
        userBizNumber: "", // 合同编号
        debtorName: "", // 债务人姓名
        debtorPhone: "", // 债务人手机号
        signStartTimeArr: [],
        certificateTimeArr: [],
        statusKey: "",
      }
      this.onSearch();
    },
    // 查询
    onSearch() {
        console.log(this.form);
        let obj = {
          contractName: this.form.contractName,
          userBizNumber: this.form.userBizNumber,
          debtorName: this.form.debtorName,
          debtorPhone: this.form.debtorPhone,
        }
        
        // 出证时间
        if (this.form.certificateTimeArr && this.form.certificateTimeArr.length) {
          obj.certificateTimeBegin = this.form.certificateTimeArr[0];
          obj.certificateTimeEnd = this.form.certificateTimeArr[1];
        } else {
          obj.certificateTimeBegin = ""
          obj.certificateTimeEnd = ""
        }
        // 导入状态处理
        if (this.form.statusKey && Object.keys(this.statusInfo).length) {
          obj.status = this.statusInfo.status;
          if (this.statusInfo.signStartTimeEnd) {
             // 创建时间-截止时间字段 和 导入状态 当日未完成 拖延三天以上 七天以上 冲突，两个仅存在一个
            obj.signStartTimeEnd = this.statusInfo.signStartTimeEnd;
            obj.signStartTimeBegin = undefined;
          } else {
            obj.signStartTimeEnd = undefined;
            obj.signStartTimeBegin = undefined;
          }
        } else {
          obj.signStartTimeBegin = undefined;
          obj.signStartTimeEnd = undefined;
          obj.status = undefined;
        }
        // 创建时间
        if (this.form.signStartTimeArr && this.form.signStartTimeArr.length) {
          obj.signStartTimeBegin = this.form.signStartTimeArr[0];
          obj.signStartTimeEnd = this.form.signStartTimeArr[1];
        }
        console.log(obj);
        this.$emit('onSearch', obj);
    },

    onStatus(item) {
      console.log(item, 'item');
      if (!item) {
        // 则认为是选中的全部按钮
        this.form.statusKey = "";
        this.statusInfo = {};
        this.onSearch();
        return;
      }
      this.form.statusKey = item.key;
      this.statusInfo = item;
      if (item.signStartTimeEnd) {
        this.form.signStartTimeArr = [];
      }
      this.onSearch();
    },

    signStartTimeChange() {
      // 创建时间选择完成后  导入状态如果是 当日未完成 拖延三天以上 拖延七天以上 则需要清空
      if (this.statusInfo.signStartTimeEnd) {
        this.statusInfo = {};
        this.form.statusKey = "";
      }
    },

    onExport() {
      this.$emit('onExport')
    }
  },
};
</script>
            
<style scoped lang='scss'>
.task_form {
  padding: 16px 14px 0;
}
.el-form-item {
  margin-bottom: 0;
}
.row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .col {
    flex: 1;
  }
  .button-box {
    flex-shrink: 0;
    width: 166px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.search-button {
  background: #f8f8f8;
  border-radius: 2px;
  border-color: #e9e9e9;
  color: #bdbdbd;
  padding: 7px 15px;
  &.el-button:focus,
  &.el-button:hover {
    color: none;
  }
}

.reset-button {
  border-radius: 2px;
  padding: 7px 15px;
  &.el-button--danger {
    color: #fff;
    background-color: #db1c1b;
    border-color: #db1c1b;
  }
}

.item-box {
  height: 40px;
  display: flex;
  align-items: center;
  .item {
    width: 80px;
    height: 26px;
    border-radius: 2px;
    border: 1px solid #e9e9e9;
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #505050;
    line-height: 26px;
    text-align: center;
    margin-right: 10px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    &:first-child {
      margin-right: 30px;
    }
    &:nth-child(5) {
      margin-right: 30px;
    }
    &.active {
      border: 1px solid #db1c1b;
      background: #db1c1b;
      color: #ffffff;
    }
  }
  .status-item-line {
    width: 1px;
    height: 26px;
    background: #db1c1b;
    margin-right: 10px;

  }
}
</style>
            